<template>
  <div class="inline-block explanation-warpper" @click.stop>
    <v-popover trigger="click" :open.sync="popoverVisible" :popoverClass="'vue-popover-theme explanation-custome'" class="hhahah">
      <span :class="['content', direction === 'right' ? 'right-bg' : 'left-bg']" @click="handleDesc"
        >{{ nouns }}
        <Icon
          :color="direction === 'right' ? '#fff' : '#666'"
          class="inline-block align-text-top w-3.5 h-3.5"
        />
      </span>
      <template #popover>
        <div class="prose prose-lg pop-center" v-html="htmlDesc"></div>
      </template>
    </v-popover>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import showdown from 'showdown';
import Icon from './assets/Icon.vue';

@Component({
  components: {
    Icon
  }
})
export default class Explanation extends Vue {
  @Prop({ type: String }) desc!: string;
  @Prop({ type: String }) nouns!: string;
  @Prop({ type: String }) direction!: String;

  popoverVisible = false;

  get htmlDesc(): string {
    const converter = new showdown.Converter({
      simpleLineBreaks: true,
      openLinksInNewWindow: true
    });
    return converter.makeHtml(this.desc);
  }

  handleDesc() {
    this.popoverVisible = false;
  }
}
</script>

<style scoped>
.content {
  @apply inline-block rounded-md px-1 mx-1;
  cursor: help;
}

.pop-center {
  @apply max-w-90vw md:max-w-2xl;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>
